module.exports = __webpack_public_path__ + "img/pic1.73397911.png";